import {
  Modal,
  ModalBody,
  Text,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
  Flex,
  Img,
} from "@chakra-ui/react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { hideDeleteProductModal, DeleteProduct, listProducts } from "../../actions/productActions";

const DeleteProductModal = () => {
  const dispatch = useDispatch();
  const productDelete = useSelector((state) => state.productDelete);
  const { modalDelete, selectedItem, loading } = productDelete;

  const onClose = () => {
    dispatch(hideDeleteProductModal());
  };

  const deleteProductHandler = () => {
    if(!selectedItem?._id) return;
    dispatch(DeleteProduct(selectedItem._id));
    setTimeout(() => {
      dispatch(listProducts());
    }, 500);
  };

  if (!modalDelete) return null;

  return (
    <Modal isOpen={modalDelete} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Eliminar Producto</ModalHeader>
        <ModalCloseButton 
            disabled={loading}
        />
        <ModalBody>
          <Text mb="20px">
            La siguiente acción es irreversible, ¿Está seguro que desea borrar
            el siguiente producto?
          </Text>
          <Flex flexDir="row" w="100%">
            <Flex
              flexDir="column"
              flex={1}
            >
              <Text>Nombre: {selectedItem?.name}</Text>
              <Text>Precio: {selectedItem?.price}</Text>
              <Text>
                Creación: {moment(selectedItem.createdAt).format("MM/DD/YYYY")}
              </Text>
              <Text>
                Descripción: {selectedItem?.description}
              </Text>
            </Flex>
            <Flex
              w="100%"
              flex={1}
              justifyContent="center"
              alignItems={"center"}
            >
              <Img
                w="100%"
                h="100%"
                objectFit="contain"
                src={selectedItem?.images[0]}
              />
            </Flex>
          </Flex>
          <Flex w="100%" justifyContent="flex-end" mt="30px" mb="10px">
            <Button 
                isLoading={loading}
                _loading={{ bg: "red.500", color: "white" }}
                onClick={deleteProductHandler}
                variant="solid" bg="red.500">
              <Text color="white">Eliminar</Text>
            </Button>
            <Button 
                disabled={loading}
                onClick={onClose}
                ml=".3em" variant="ghost">
              <Text color="gray.600">Cancelar</Text>
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DeleteProductModal;
